import { IconCircleX } from './IconCircleX'

export default IconCircleX
